import dayjs from "dayjs";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var partElements = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        margin: '12px',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'UOM:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'UOM',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.UOM) {
                                var UOM = formData !== null && formData !== void 0 && formData.UOM ? formData === null || formData === void 0 ? void 0 : formData.UOM : '-';
                                return UOM;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Service type:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ContractTypeName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Technician:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'MechanicName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.MechanicName) {
                                var MechanicName = formData !== null && formData !== void 0 && formData.MechanicName ? formData === null || formData === void 0 ? void 0 : formData.MechanicName : '-';
                                return MechanicName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Complaint name:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ComplaintName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.ComplaintName) {
                                var ComplaintName = formData !== null && formData !== void 0 && formData.ComplaintName ? formData === null || formData === void 0 ? void 0 : formData.ComplaintName : '-';
                                return ComplaintName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Customer complaint name:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'CustomerComplaintName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.CustomerComplaintName) {
                                var CustomerComplaintName = formData !== null && formData !== void 0 && formData.CustomerComplaintName ? formData === null || formData === void 0 ? void 0 : formData.CustomerComplaintName : '-';
                                return CustomerComplaintName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Rate(₹):',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Rate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (params) {
                            var value = Number(params === null || params === void 0 ? void 0 : params.Rate);
                            if (value) {
                                return value === null || value === void 0 ? void 0 : value.toFixed(2);
                            }
                            else {
                                return '';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Quantity:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Qty',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Amount(₹) :',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Amount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (params) {
                            var value = Number(params === null || params === void 0 ? void 0 : params.Amount);
                            if (value) {
                                return value === null || value === void 0 ? void 0 : value.toFixed(2);
                            }
                            else {
                                return '';
                            }
                        }
                    }]
            }]
    }];
export var labourElements = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        margin: '12px',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Service type:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ContractTypeName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Technician:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'MechanicName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.MechanicName) {
                                var MechanicName = formData !== null && formData !== void 0 && formData.MechanicName ? formData === null || formData === void 0 ? void 0 : formData.MechanicName : '-';
                                return MechanicName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Unit:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Qty',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Rate (₹) :',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Rate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (params) {
                            var value = Number(params === null || params === void 0 ? void 0 : params.Rate);
                            if (value) {
                                return value === null || value === void 0 ? void 0 : value.toFixed(2);
                            }
                            else {
                                return '';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Start date time:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'StartDateTime',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.StartDateTime) {
                                var StartDateTime = formData !== null && formData !== void 0 && formData.StartDateTime ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.StartDateTime).format('DD MMM, YYYY') : '-';
                                return StartDateTime;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'End date time:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'EndDateTime',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.EndDateTime) {
                                var EndDateTime = formData !== null && formData !== void 0 && formData.EndDateTime ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.EndDateTime).format('DD MMM, YYYY') : '-';
                                return EndDateTime;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Out side labour:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'IsOutside',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.IsOutside) {
                                var IsOutside = formData !== null && formData !== void 0 && formData.IsOutside ? formData === null || formData === void 0 ? void 0 : formData.IsOutside : '-';
                                return IsOutside;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Amount(₹) :',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Amount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (params) {
                            var value = Number(params === null || params === void 0 ? void 0 : params.Amount);
                            if (value) {
                                return value === null || value === void 0 ? void 0 : value.toFixed(2);
                            }
                            else {
                                return '';
                            }
                        }
                    }]
            }]
    }];
